import { Sparkles } from 'lucide-react';

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <div className="space-y-8 py-6">
      <div className="text-center space-y-3">
        <div className="flex justify-center">
          <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
            <Sparkles className="w-7 h-7 text-white" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Welcome to Patent Loop!</h1>
        <p className="text-base text-gray-600 max-w-2xl mx-auto">
          Your AI-powered assistant for patent analysis, prosecution, and research
        </p>
      </div>

      <div className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 border-2 border-blue-200 rounded-xl p-8">
        <div className="text-center space-y-4">
          <p className="text-lg text-gray-700">
            Let's get you started in less than a minute
          </p>
          <p className="text-gray-600">
            In the next step, we'll help you jump straight into what you want to do —
            whether that's analyzing documents, checking prosecution history, examining office actions,
            or looking up patent laws.
          </p>
        </div>
      </div>

      <div className="flex justify-center">
        <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm">
          <Sparkles className="w-4 h-4" />
          <span>Takes less than 60 seconds</span>
        </div>
      </div>
    </div>
  );
}
